import { gql } from '@apollo/client';

const schema = {
  assignment: {
    name: 'setCouponUser',
    serviceName: 'unitadmin',
    query: gql`
      mutation setCouponUser($coupon_id: String, $user_ids: [String]!, $send_sms: [String]) {
        setCouponUser(user_ids: $user_ids, coupon_id: $coupon_id, send_sms: $send_sms) {
          messages
        }
      }
    `,
  },
};

export default schema;
